import styled from 'styled-components'
import { H3, P2 } from '../../styled/typography/typography';

export const H3PolicyModal = styled(H3)`
  margin: 35px auto 20px;
`

export const P2PolicyModal = styled(P2)`
  padding: 0 50px;
  text-align: center;
`
